<template>
	<div>
		<managing-section>
			<managing-box title="이동"> {{ params.moveCnt }}건 </managing-box>
			<managing-box title="교체"> {{ params.changeCnt }}건 </managing-box>
			<managing-box title="유지"> {{ params.holdCnt }}건 </managing-box>
		</managing-section>
		<div class="btn-wrap-main">
			<button class="btn-main blue" type="button" @click="confirm">
				확인
			</button>
		</div>
	</div>
</template>

<script>
	import { mapState } from 'vuex';
	import ManagingSection from '@/components/layout/ManagingSection.vue';
	import ManagingBox from '@/components/layout/ManagingBox.vue';

	export default {
		name: 'ProductReviewMoveResult',
		components: { ManagingSection, ManagingBox },
		computed: {
			...mapState({
				params: state => state.modal.params,
			}),
		},
		beforeDestroy() {
			window.location.reload();
		},
		methods: {
			close() {
				this.$store.commit('modal/toggleModal', false);
			},
			confirm() {
				this.close();
			},
		},
	};
</script>
